import moment from 'moment';
import { getData } from '@/components/report/service';
import { crudRequest2 } from '@/services/api';
import { chunkArrayInGroups, fuzzyQuery } from '@/utils';
import { SqlBase } from '../../common';
import { VolumesQuery } from '../Sql';

export default {
  namespace: 'centerDepartBoardVolumes',
  state: {
    allData: [], // 全部数据列表
    screenData: [], // 筛选后数组
    dataList: [], // 当前页
    total: 0,
    page: 1,
  },
  effects: {
    *getSelect({ payload }, { put }) {
      yield put({
        type: 'update',
        payload: { ...payload },
      });
      yield put({ type: 'getList' });
    },
    // 获取所以数据列表
    *getList(_, { call, put, select }) {
      let centerFilter = yield select(({ centerDepartBoard }) => centerDepartBoard.searchParams.centerFilter);
      let query = yield select(({ centerDepartBoard }) => {
        const searchParams = centerDepartBoard.searchParams;
        const start = moment(searchParams.dateRange[0]).day();
        return {
          startDate: moment(searchParams.dateRange[0]).format(centerDepartBoard.defualtDateFormat),
          endDate: moment(searchParams.dateRange[1]).format(centerDepartBoard.defualtDateFormat),
          period: start === 0 ? 7 : start,
          departureCenter: searchParams.centerFilter
        }
      });
      const departure = yield call(crudRequest2, {
        period: query.period,
        departureCenter: query.departureCenter
      });
      const departureItem = departure.data && departure.data.length > 0 ? departure.data : []
      const filter = VolumesQuery({
        scanSite: centerFilter,
        nextSites: []
      });
      const data = yield call(getData, { ...{
        startDate: query.startDate,
        endDate: query.endDate,
        aggregators: SqlBase(),
      }, ...filter[0]});
      if (data) {
        const result = [];
        const nextSites = [];
        data.forEach((item, index) => {
          item.index = index;
          nextSites.push(item.nextSite);
          const nextSite = item.nextSite.replace('分拨中心', '');
          let volumes = departureItem.find(item2 => nextSite === item2.arrivalCenter);
          if (volumes) {
            item.volumes = volumes.volumes;
          }
        })
        data.forEach((item, index) => {
          item.index = index;
          nextSites.push(item.nextSite);
        });
        const paramsfilter = VolumesQuery({
          scanSite: centerFilter,
          nextSites: nextSites
        });
        for (let i = 0; i < filter[1].length; i++) {
          const _d = yield call(getData, { ...{
            startDate: query.startDate,
            endDate: query.endDate,
            aggregators: SqlBase(),
          }, ...paramsfilter[1][i] });
          result.push(_d || []);
        }
        data.forEach(item => {
          result.forEach((item2, index2) => {
            const obj = item2.find(item3 => item.nextSite === item3.nextSite);
            if (obj) {
              item[`goodsVolume${index2}`] = obj.goodsVolume;
              item[`goodsWeight${index2}`] = obj.goodsWeight;
              item[`piece${index2}`] = obj.piece;
              item[`ticket${index2}`] = obj.ticket;
            }
          })
        })

        yield put({
          type: 'update',
          payload: {
            dataList: data
          },
        });
      }
    },
  },
  reducers: {
    update(state, { payload }) {
      return { ...state, ...payload };
    },
  }
}